"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var PayeeList = function PayeeList(_ref) {
  var fields = _ref.fields,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("table", {
    className: "revisions-revisor__payee-list"
  }, fields.map(function (field, index) {
    return children(field, index);
  }));
};
PayeeList.propTypes = {
  fields: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  children: _propTypes.default.func.isRequired
};
var _default = PayeeList;
exports.default = _default;
